var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideoChat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_25",
    "data-name": "Layer 25"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m50 3.4h-36a10.62 10.62 0 0 0 -10.6 10.6v36a10.62 10.62 0 0 0 10.6 10.6h36a10.62 10.62 0 0 0 10.6-10.6v-36a10.62 10.62 0 0 0 -10.6-10.6zm3.55 38.12a1.69 1.69 0 0 1 -1.71 0l-9.32-5.37v-8.3l9.32-5.37a1.71 1.71 0 0 1 2.56 1.52v16a1.7 1.7 0 0 1 -.85 1.52zm-41-22.21a1.72 1.72 0 0 1 1.71-1.71h25.36a1.71 1.71 0 0 1 1.7 1.71v25.38a1.71 1.71 0 0 1 -1.7 1.71h-25.39a1.72 1.72 0 0 1 -1.71-1.71z",
    fill: "#33d9b2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoChat);
export default __webpack_public_path__ + "static/media/video_chat.9913a94ab4f081e884c33a5bc73234d2.svg";
export { ForwardRef as ReactComponent };